import React from "react";
import { createRoot } from 'react-dom/client';
import App from "../components/MediaToolkit/App";

const renderMediaToolkit = ($) => {
	const mediaToolkitBlock = $("#js-data-media-items")[0];

	let props = {
		...(mediaToolkitBlock && mediaToolkitBlock.dataset),
	};

	if (mediaToolkitBlock) {
		const root = createRoot(mediaToolkitBlock);
		root.render(<App {...props}/>);
	}
};

export default renderMediaToolkit;
